import { CustomHomepageGrid, FeaturedDocsCard, HomePageCompanyLogo, HomePageRandomJoke, HomePageRecentlyVisited, HomePageStarredEntities } from "@backstage/plugin-home";
import { HomePageSearchBar } from "@backstage/plugin-search";
import { useTheme } from "@material-ui/core";

import LogoFullImageNegative from "../Root/logo/KV-Logo-Color-Negative.png";
import LogoFullImage from "../Root/logo/KV-Logo-Color.png";



const defaultConfig = [
  {
    component: "HomePageCompanyLogo",
    x: 5,
    y: 0,
    width: 12,
    height: 10,
    deletable: false,
    movable: false,
    resizable: false,
  },
  {
    component: "HomePageSearchBar",
    x: 0,
    y: 4,
    width: 12,
    height: 5,
  }, {
    component: "HomePageRecentlyVisited",
    x: 0,
    y: 4,
    width: 6,
    height: 16,
  }, {
    component: "HomePageStarredEntities",
    x: 6,
    y: 4,
    width: 6,
    height: 16,
  },
];


export const HomePage = () => {
  const theme = useTheme();

  return (
    <CustomHomepageGrid
      config={defaultConfig}
      rowHeight={10}
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      containerPadding={[10, 10]}
    >
      <HomePageCompanyLogo
        logo={
          <img height="auto"
            width="auto"
            src={theme.palette.type === "dark" ? LogoFullImageNegative : LogoFullImage}
            alt="Kinetic Vision Logo" />
        }
      />
      <HomePageSearchBar />
      <HomePageRecentlyVisited />
      <HomePageStarredEntities />
      <FeaturedDocsCard filter={[]} />
      <HomePageRandomJoke />
    </CustomHomepageGrid>
  );
};
